<template>
	<span>
		<a
			:href="`#footnote-${footnote}`"
			class="footnote-link"
			@click="onClick"
			:data-rpa-tag-id="dataRPATagId"
			:aria-label="`See footnote ${footnote}`"
			>{{ footnote }}</a
		>
		<v-breakpoint v-model="model" />
	</span>
</template>

<script>
import { VBreakpoint, Model, EventBus } from "@vg-faset/core";
let VueScrollTo = require("vue-scrollto");

/**
 * This component can be used in tandem with ArticleDisclaimersFootnotes.vue
 */
export default {
	name: "FootnoteLink",
	props: {
		/**
		 * The footnote number or symbol.
		 */
		footnote: {
			type: [String, Number]
		},

		/**
		 * Include an additional offset value. Use a positive number to add some space above the jump target, use a negative number for the opposite effect
		 */
		offset: {
			type: Number,
			default: 0
		},

		/**
		 * If this is set to true it will pass the `doScroll` function as a callback to the "footnote:jump" global event. Why? If you are trying to jump to a hidden element (e.g. The disclaimers and footnotes hidden in a drawer on Article pages) then you'll need to use this instead because otherwise Scrollto will not work. It can not jump to an element that's inside a display:none.
		 */
		useCallback: {
			type: Boolean,
			default: false
		},

		/**
		 * The data-rpa-tag-id attribute value for the footnote link.
		 */
		dataRPATagId: {
			type: String,
			default: ""
		}
	},
	components: { VBreakpoint },
	data() {
		return {
			model: new Model()
		};
	},
	methods: {
		getOffset() {
			let inPageNav = document.getElementById("in-page-nav");
			if ((this.model.isMedium || this.model.isLarge) && inPageNav) {
				return inPageNav.scrollHeight * -1 - 50 - this.offset;
			} else {
				return -25 - this.offset;
			}
		},
		doScroll() {
			VueScrollTo.scrollTo(`#footnote-${this.footnote}`, {
				offset: this.getOffset()
			});
		},
		onClick(e) {
			e.preventDefault();
			if (this.useCallback) {
				EventBus.$emit("footnote:jump", this.doScroll.bind(this));
				return;
			}
			EventBus.$emit("footnote:jump", true);
			this.doScroll();
		}
	}
};
</script>
